import { render, staticRenderFns } from "./DespegarHistory.vue?vue&type=template&id=23f8aa60&scoped=true"
import script from "./DespegarHistory.vue?vue&type=script&lang=js"
export * from "./DespegarHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8aa60",
  null
  
)

export default component.exports